import { API } from '../api'
import { LogisticsParams } from './interface'

export const post = async (
  filtros: Record<string, any>
): Promise<{
  content: string
  isSuccess: boolean
}> => {
  try {
    const formData = new FormData()

    filtros.colaboradores.forEach(colaborador => {
      formData.append('Ids[]', colaborador || null)
    })
    formData.append('PedidoNaOperadora', filtros.numeroPedidoOperadora || null)
    formData.append('IdPostoColeta', filtros.postoDeColeta || null)
    formData.append('IdFornecedor', filtros.idFornecedor || null)
    formData.append('AtualizadoPor', filtros.atualizadoPor || null)
    formData.append('SegundaVia', filtros.viaDosCartoes || null)
    formData.append('TaxaDeRetirada', filtros.taxaDeRetirada || null)
    formData.append('Observacao', filtros.observacoes || null)
    formData.append('DataLiberacao', filtros.dataLiberacao || null)
    filtros.arquivo.forEach(file => {
      formData.append('Files', file)
    })

    const response = await API.post<LogisticsParams>(
      '/logistica/solicitar-logistica',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )

    return response
  } catch (error) {
    console.error('Erro ao solicitar logística:', error)
    return null
  }
}
